import { useEffect, useRef } from "react";

function useTimeout(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    function timeout() {
      savedCallback.current();
    }

    if (delay !== null) {
      let id = setTimeout(timeout, delay);
      return () => clearTimeout(id);
    }
  }, [delay]);
}

export default useTimeout;
